import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-4 right-4 z-50 w-96"
}
const _hoisted_2 = { class: "bg-white rounded-lg shadow-2xl border border-gray-200" }
const _hoisted_3 = { class: "flex items-center justify-between px-4 py-2 border-b bg-gray-50 rounded-t-lg" }
const _hoisted_4 = { class: "font-semibold text-xs text-gray-700" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = ["aria-label", "title"]
const _hoisted_7 = {
  class: "w-4 h-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_8 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5 15l7-7 7 7"
}
const _hoisted_9 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}
const _hoisted_10 = {
  key: 0,
  class: "overflow-y-auto max-h-48"
}
const _hoisted_11 = {
  key: 1,
  class: "px-4 py-3 text-xs text-gray-600"
}

import { onMounted, ref, watch } from "vue";
import { useBulkUploadStore } from "@/stores/bulkUploadStore";
import BulkUploadStatusItem from "./BulkUploadStatusItem.vue";

const COLLAPSE_KEY = "slashexperts_bulk_uploads_collapsed";

export default /*@__PURE__*/_defineComponent({
  __name: 'BulkUploadStatusBar',
  setup(__props) {

const store = useBulkUploadStore();
const isCollapsed = ref(false);

const toggleCollapsed = () => {
  isCollapsed.value = !isCollapsed.value;
};

onMounted(() => {
  // Store auto-loads from localStorage on initialization
  // This is just for explicit re-check on mount
  store.loadFromStorage();

  try {
    isCollapsed.value = localStorage.getItem(COLLAPSE_KEY) === "true";
  } catch {
    // ignore
  }
});

watch(isCollapsed, (val) => {
  try {
    localStorage.setItem(COLLAPSE_KEY, val ? "true" : "false");
  } catch {
    // ignore
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).hasActiveUploads)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, " Uploads (" + _toDisplayString(_unref(store).uploadCount) + ") ", 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                onClick: toggleCollapsed,
                class: "text-gray-500 hover:text-gray-700 transition-colors",
                "aria-label": isCollapsed.value ? 'Expand uploads' : 'Collapse uploads',
                title: isCollapsed.value ? 'Expand' : 'Collapse'
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                  (isCollapsed.value)
                    ? (_openBlock(), _createElementBlock("path", _hoisted_8))
                    : (_openBlock(), _createElementBlock("path", _hoisted_9))
                ]))
              ], 8, _hoisted_6),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).clearAll())),
                class: "text-xs text-gray-500 hover:text-red-600 transition-colors font-medium"
              }, " Clear All ")
            ])
          ]),
          (!isCollapsed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).activeUploads, ([uploadId, upload]) => {
                  return (_openBlock(), _createBlock(BulkUploadStatusItem, {
                    key: uploadId,
                    "upload-id": uploadId,
                    upload: upload
                  }, null, 8, ["upload-id", "upload"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, " Uploads are running in the background. "))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})